import axios_ from "../utils/axios";

/**
 * 社媒-数据汇总接口
 */
export default {
  data_summary: {
    /**
     * 获取团队下添加舆情监控的主页数量
     * @param {{page_auth_status?: number|string; label_id?: number|string}} query
     * @returns {Promise<DefaultResponseType>}
     */
    monitored_accounts(query = {}) {
      return axios_(
        "GET",
        "api/pandagpt/v1/data_summary/monitored_accounts",
        query,
        false,
        false,
        true,
        false
      );
    },

    /**
     * 获取概览数据、趋势图数据、分布图数据
     * @param {{page_auth_status?: number|string; platform_str?: string; start_date: string; end_date: string; label_id?: number|string}} query
     * @returns {Promise<DefaultResponseType>}
     */
    overview(query) {
      return axios_("GET", "api/pandagpt/v1/data_summary/overview", query, false, false, true, false);
    },

    /**
     * 获取最佳贴文 TOP10
     * @param {{page_auth_status?: number|string; platform_str?: string; start_date: string; end_date: string; top_type: number|string; label_id?: number|string}} query
     * @returns {Promise<DefaultResponseType>}
     */
    top(query) {
      return axios_("GET", "api/pandagpt/v1/data_summary/top", query, false, false, true, false);
    },

    /**
     * 获取指定平台的监控账号明细
     * @param {{platform: number|string; page_auth_status?: number|string; label_id?: number|string}} query
     * @returns {Promise<DefaultResponseType>}
     */
    monitored_account_detail(query = {}) {
      return axios_(
        "GET",
        "api/pandagpt/v1/data_summary/monitored_account_detail",
        query,
        false,
        false,
        true,
        false
      );
    },
  },
};
